const getters = {
  // userInfo: state => state.user.userInfo,
  // dicts: state => state.dict.dicts,
  // defaultPageSize: state => state.dict.defaultPageSize
  microscope: state => state.microscope.handleMicroscope,
}
export default getters
